module.exports = __webpack_public_path__ + "static/img/p_icon2.208c5ab8.png";